import { Badge } from 'react-bootstrap'

type Props = {
    avatarLink?: string
    shortIdentifier?: string
}

const SupportAvatar = (props:Props)=>{
    const { shortIdentifier, avatarLink } = props
    if(!avatarLink) {
        return <i className="bi-person-circle text-warning"  style={{position: 'relative', fontSize: '50px', lineHeight: 1, filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.4))"}}>
                {shortIdentifier && <Badge bg='warning' className="text-white text-center w-100" style={{position: 'absolute', fontSize: '16px', bottom: -15, left: 0, fontStyle: 'normal'}}>{shortIdentifier}</Badge>}
            </i>
    }

    return <i className="bi-circle text-warning"  style={{position: 'relative', fontSize: '50px', lineHeight: 1, filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.4))"}}>
                <img src={props.avatarLink} alt="User Avatar" style={{borderRadius: '50%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '40px', height: '40px'}} />
                {shortIdentifier && <Badge bg='warning' className="text-white text-center w-100" style={{position: 'absolute', fontSize: '16px', bottom: -15, left: 0, fontStyle: 'normal'}}>{shortIdentifier}</Badge>}
            </i>
}

export default SupportAvatar